import { config } from "../config";
import { getAuthToken } from "../util/auth";

export const getLists = async () => {
    const response = await fetch(`${config.url}/lists/lists`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Fetching lists Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createListApi = async (form) => {
    const response = await fetch(`${config.url}/lists/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(form)
    });

    if (!response.ok) {
        throw new Error('Create list Faild');
    }

    const resData = await response.json();
    return resData;
}

export const getList = async (listId) => {
    const response = await fetch(`${config.url}/lists/list/${listId}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Fetching list Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewColumnApi = async (listId, viewId, formData) => {
    const response = await fetch(`${config.url}/lists/${listId}/${viewId}/add-column`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(formData)
    });

    if (!response.ok) {
        throw new Error('Create new column Faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateListDataApi = async (listId, form) => {
    const response = await fetch(`${config.url}/lists/${listId}/update-data`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(form)
    });

    if (!response.ok) {
        throw new Error('Update list data Faild');
    }

    const resData = await response.json();
    return resData;
}

export const getBelongsToListDataApi = async (listId) => {
    const response = await fetch(`${config.url}/lists/list/${listId}/data`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Fetching BelongsToListData Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createRowApi = async (listId, formData) => {
    const response = await fetch(`${config.url}/lists/${listId}/add-row`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: formData
    });

    if (!response.ok) {
        throw new Error('Create new row Faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteColumnApi = async (currentListId, columnId) => {
    const response = await fetch(`${config.url}/lists/${currentListId}/delete-column/${columnId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    const resData = await response.json();

    if (!response.ok) {
        if (response.status === 499) {
            throw new Error(resData.message + ' ' + resData.data.join(', '));
        } else {
            throw new Error('Delete Column Faild');
        }
    }

    return resData;
}

export const deleteRowsApi = async (listId, rowsToDelete) => {
    const response = await fetch(`${config.url}/lists/${listId}/delete-rows`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ rowsToDelete: rowsToDelete })
    });

    if (!response.ok) {
        throw new Error('Delete Rows Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveActiveViewApi = async (listId, activeViewId, activeViewColumns) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/save-view`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ columns: activeViewColumns })
    });

    if (!response.ok) {
        throw new Error('Save active view Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveViewAsApi = async (listId, activeViewId, viewName, activeViewColumns) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/save-view-as`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name: viewName, columns: activeViewColumns })
    });

    if (!response.ok) {
        throw new Error('Save view as Faild');
    }

    const resData = await response.json();
    return resData;
}

export const setCurrentViewAsDefaultApi = async (listId, activeViewId) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/set-view-as-default`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('set current view as default Faild');
    }

    const resData = await response.json();
    return resData;
}

export const renameViewApi = async (listId, activeViewId, viewName) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/rename-view`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name: viewName })
    });

    if (!response.ok) {
        throw new Error('Rename view Faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteViewApi = async (listId, activeViewId) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/delete-view`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Delete view Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveViewColumnsApi = async (listId, activeViewId, viewColumns) => {
    const response = await fetch(`${config.url}/lists/${listId}/view/${activeViewId}/save-columns`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ columns: viewColumns })
    });

    if (!response.ok) {
        throw new Error('Save view columns Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createViewApi = async (listId, formData) => {
    const response = await fetch(`${config.url}/lists/${listId}/add-view`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(formData)
    });

    if (!response.ok) {
        throw new Error('Create view Faild');
    }

    const resData = await response.json();
    return resData;
}

export const editRowApi = async (listId, rowId, formData) => {
    const response = await fetch(`${config.url}/lists/${listId}/edit-row/${rowId}`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: formData
    });

    if (!response.ok) {
        throw new Error('Edit row Faild');
    }

    const resData = await response.json();
    return resData;
}

export const editBoardViewRowApi = async (listId, updatedRowId, columnId, value) => {
    const response = await fetch(`${config.url}/lists/${listId}/edit-board-view-row/${updatedRowId}/${columnId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ value })
    });

    if (!response.ok) {
        throw new Error('Edit board view row Faild');
    }

    const resData = await response.json();
    return resData;
}

export const getListRowCommentsApi = async (lId, rId) => {
    const response = await fetch(`${config.url}/listComments/comments/${lId}/${rId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching list row comments Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createListRowCommentApi = async (lId, rId, commentContent) => {
    const response = await fetch(`${config.url}/listComments/createComment/${lId}/${rId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ content: commentContent })
    });

    if (!response.ok) {
        throw new Error('Creating list row comment Faild');
    }

    const resData = await response.json();
    return resData;
}

export const getListRowFilesApi = async (lId, rId) => {
    const response = await fetch(`${config.url}/listFiles/files/${lId}/${rId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
    });

    if (!response.ok) {
        throw new Error('Fetching list row files Faild');
    }

    const resData = await response.json();
    return resData;
}

export const moveStorageNodesToApi = async (baseListId, baseRowId, nodesIds, toNodeId) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-move-nodes/${baseListId}/${baseRowId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ nodes: nodesIds, toNodeId })
    });

    if (!response.ok) {
        throw new Error('Move Nodes To Node Faild');
    }

    const resData = await response.json();
    return resData;
}

export const hideFileManagerColumnApi = async (bLId, colId) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-hide-column/${bLId}/${colId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Hide file manager column Faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteFileManagerColumnApi = async (bLId, colId) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-delete-column/${bLId}/${colId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        }
    });

    if (!response.ok) {
        throw new Error('Delete file manager column Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createStorageNewColumnApi = async (currListId, fData) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-add-column/${currListId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(fData)
    });

    if (!response.ok) {
        throw new Error('Create new column Faild');
    }

    const resData = await response.json();
    return resData;
}

export const editStorageColumnApi = async (currListId, colId, fData) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-edit-column/${currListId}/column/${colId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify(fData)
    });

    if (!response.ok) {
        throw new Error('Edit column Faild');
    }

    const resData = await response.json();
    return resData;
}

export const createNewFolderApi = async (baseListId, baseRowId, name, currPath) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-create-folder/${baseListId}/${baseRowId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ name, currentPath: currPath })
    });

    if (!response.ok) {
        throw new Error('Create Folder Faild');
    }

    const resData = await response.json();
    return resData;
}

export const updateRowFieldApi = async (baseListId, baseRowId, fileManagerRowId, fileManagerColumnId, value) => {
    const response = await fetch(`${config.url}/listFiles/update-row-field/${baseListId}/row/${baseRowId}/fileManager/${fileManagerRowId}/column/${fileManagerColumnId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ value })
    });

    if (!response.ok) {
        throw new Error('Edit row Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveColumnDataApi = async (baseListId, updatedColumns) => {
    const response = await fetch(`${config.url}/listFiles/fileManagerList/saveColumnData/${baseListId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ updatedColumns })
    });

    if (!response.ok) {
        throw new Error('Edit row Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveFileManagerColumnsApi = async (baseListId, fileManagerColumns) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-showHide-column/${baseListId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ updatedColumns: fileManagerColumns })
    });

    if (!response.ok) {
        throw new Error('Save file manager columns Faild');
    }

    const resData = await response.json();
    return resData;
}

export const deleteSelectedStorageRowsApi = async (baseListId, baseRowId, rowsToDelete) => {
    const response = await fetch(`${config.url}/listFiles/file-manager-delete-rows/${baseListId}/${baseRowId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ rowsToDelete })
    });

    if (!response.ok) {
        throw new Error('Delete rows Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveViewSortingApi = async (activeListId, activeViewId, selectedColumn, selectedSortingType) => {
    const response = await fetch(`${config.url}/lists/save-sorting/${activeListId}/view/${activeViewId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ selectedColumn, selectedSortingType })
    });

    if (!response.ok) {
        throw new Error('Save view sorting Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveViewfiltersApi = async (activeListId, activeViewId, filters) => {
    const response = await fetch(`${config.url}/lists/save-filters/${activeListId}/view/${activeViewId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ filters })
    });

    if (!response.ok) {
        throw new Error('Save view filters Faild');
    }

    const resData = await response.json();
    return resData;
}

export const saveApiFieldsApi = async (activeListId, apiFields, listApiField) => {
    const response = await fetch(`${config.url}/lists/update-api-fields/${activeListId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getAuthToken()
        },
        body: JSON.stringify({ apiFields, listApiField })
    });

    if (!response.ok) {
        throw new Error('update api fields Faild');
    }

    const resData = await response.json();
    return resData;
}